var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalIcon = function SvgExternalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#001B40",
    clipPath: "url(#external-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 8.424V14H0V0h5.152v1.04H.967v11.921h11.067V8.424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6.242V0H7.18v1.04h4.176L6.171 6.615l.663.71 5.2-5.59v4.507z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "external-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h13v14H0z"
  })))));
};
export default SvgExternalIcon;